import { Component, Input } from '@angular/core';

@Component({
    selector: 'se-flatpanel',
    templateUrl: './se-flatpanel.component.html',
    styleUrls: ['./se-flatpanel.component.less'],
})
export class SeFlatPanelComponent {
    // data members

    @Input()
    title: string;

    @Input()
    isInternalPanel = false;
}
